function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var PendoHelper = /*#__PURE__*/function () {
  function PendoHelper() {
    _classCallCheck(this, PendoHelper);
  }

  _createClass(PendoHelper, null, [{
    key: "Install",
    value: function Install(apiKey) {
      (function (p, e, n, d, o) {
        var v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = o._q || [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];

        for (w = 0, x = v.length; w < x; ++w) {
          (function (m) {
            o[m] = o[m] || function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
          })(v[w]);
        }

        y = e.createElement(n);
        y.async = !0;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');
    }
  }, {
    key: "Initialize",
    value: function Initialize(config) {
      if (!config) {
        return;
      }

      pendo.initialize(config);
    }
  }, {
    key: "Init",
    value: function Init(apiKey, config) {
      this.Install(apiKey);
      this.Initialize(config);
    }
  }]);

  return PendoHelper;
}();
window.PendoHelper = PendoHelper;